import { SaleBanner } from '@wix/app-market-components';
import React, { useEffect } from 'react';
import { useManageAppsBi } from '../../useManageAppsBi';
import { useExperiments } from '@wix/wix-experiments-react';
export const AppMarketSaleBanner = ({ goToHomePage, msid, origin, i18n, }) => {
    const { experiments } = useExperiments();
    const isWixSaleEnabled = experiments.enabled('specs.app-market.Sale');
    const { appMarketSaleBannerClicked, appMarketSaleBannerImpression } = useManageAppsBi();
    useEffect(() => {
        if (isWixSaleEnabled) {
            appMarketSaleBannerImpression({ msid, origin });
        }
    }, [origin, msid, isWixSaleEnabled, appMarketSaleBannerImpression]);
    return (isWixSaleEnabled && (React.createElement(SaleBanner, { i18n: i18n, layout: 'narrow', onClick: () => {
            appMarketSaleBannerClicked({ msid, origin });
            goToHomePage();
        } })));
};
//# sourceMappingURL=app-market-sale-banner.js.map